import { Directive, HostListener, Input } from '@angular/core';
import { Config } from '../config';
import { Subject } from 'rxjs';

@Directive({
	standalone: true,
	selector: '[delayedSearch]',
})
export class DelayedSearchDirective {
	@Input()
	set delayedSearch(filterValue: Subject<string>) {
		this.filterValue = filterValue;
	}

	private searchTimeout: number;
	private searchTimeoutDelay = Config.SEARCH_DELAY;
	private filterValue: Subject<string>;
	private filterExecuted = false;

	constructor() {}

	@HostListener('keyup', ['$event']) onKeyUp($event) {
		if (this.searchTimeout) {
			clearTimeout(this.searchTimeout);
		}
		this.searchTimeout = setTimeout((event) => {
			if (!this.filterExecuted) this.filterValue.next($event.target.value);
			this.filterExecuted = false;
		}, this.searchTimeoutDelay);
	}

	@HostListener('search', ['$event']) onSearch($event) {
		if (this.searchTimeout) {
			clearTimeout(this.searchTimeout);
		}
		this.filterValue.next($event.target.value);
		this.filterExecuted = true;
		// Add a sligthly longer timeout than in the keyup event to prevent the search from being triggered twice,
		// if search event is fired by pressing enter.
		// This is due to the fact, that enter fires both search and keyup event
		setTimeout((event) => {
			this.filterExecuted = false;
		}, this.searchTimeoutDelay + 100);
	}
}
